var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-chat",attrs:{"href":_vm.whatsappUrl,"target":"_blank"}},[_c('img',{attrs:{"src":require("@/assets/whatsapp.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }